const Images = {
  assistance: {
    no_other_image: require('../../../assets/images/assistance-nopicture.jpg'),
    assistance_instant_help: require('../../../assets/images/assistance_instant_help.png'),
    assistance_schedule: require('../../../assets/images/assistance_schedule.png'),
    assistance_contacts: require('../../../assets/images/assistance_contacts.png'),
    assistance_therapy: require('../../../assets/images/assistance-therapy-6.png'),
    helpdesk: require('../../../assets/images/helpDeskBackground.png'),
    background0: require('../../../assets/images/background0.png'),
    background1: require('../../../assets/images/background1.png'),
    background2: require('../../../assets/images/background2.png'),
    background3: require('../../../assets/images/background3.png'),
    background4: require('../../../assets/images/background4.png'),
    ghostImage: require('../../../assets/images/ghost.jpg'),
    magnifying_class: require('../../../assets/images/MagnifyingGlass.png'),
  },
  illustrations: {
    flower: require('../../../assets/images/illustrations/flower.jpg'),
    medal: require('../../../assets/images/illustrations/medal.jpg'),
    update_app: require('../../../assets/images/illustrations/update_app.png'),
    feedback_heart: require('../../../assets/images/illustrations/feedback_heart.png'),
    onboarding_survey: require('../../../assets/images/illustrations/onboarding_survey.png'),
    reckoning_survey: require('../../../assets/images/illustrations/reckoning_survey.png'),
  },
  breathe: {
    times: require('../../../assets/images/timer.png'),
  },
  faceScan: {
    card: require('../../../assets/images/cards/face_scan.png'),
  },
  settings: {
    iconArrowSettings: require('../../../assets/images/arrow-settings.png'),
  },
  logo: {
    multicolor: require('../../../assets/images/evoluno/multicolor.png'),
    icon: require('../../../assets/images/evoluno/icon.png'),
    logoAndText: require('../../../assets/images/evoluno/logoAndText.png'),
  },
  other: {
    lightbulb: require('../../../assets/images/lightbulb.png'),
    recommendation: require('../../../assets/images/background_recommendation.png'),
  }
};

export default Images;
